<div class="default-container">
    <div class="wrapper">
        <div class="container-breadcrumbs">
            <app-breadcrumbs
                formerPage="{{
                    (planning ? 'COMMON.BREADCRUMBS.PLANNING_PROJECT' : 'COMMON.BREADCRUMBS.OVERVIEW') | translate
                }}"
                currentPage="{{ 'COMMON.BREADCRUMBS.CONFIGURATION' | translate }}"
                [navigateTo]="planning ? ['../', 'planning-project', salesforceId] : '/overview'"
            ></app-breadcrumbs>
        </div>
        <div class="container-content" [class.hidden]="!isQuestFormReady">
            <div class="content-content" [class.quest-lib-container-min-height]="isQuestFormReady">
                <div class="content-header">
                    <h2>{{ 'CONFIGURATION.TITLE' | translate }} {{ quickRef }}</h2>
                </div>
                <div
                    class="info-item info-warning"
                    *ngIf="hasProductErrors | async"
                    [innerHTML]="'COMMON.ERRORS.PRODUCT_NOT_AVAILABLE' | translate"
                ></div>
                <app-questionnaire
                    #questionaire
                    [quoteId]="quoteId"
                    [title]="offerTitle"
                    [salesforceId]="salesforceId"
                    [planning]="planning"
                    [quotationRequestId]="quotationRequestId"
                    (isReady)="onQuestFormReady()"
                    (isComplete)="onQuestFormComplete($event)"
                    [lineType]="lineType"
                ></app-questionnaire>
            </div>
            <div class="content-sidebar" *ngIf="isQuestFormReady">
                <div class="sidebar-sticky">
                    <app-customer-selection *ngIf="permissionService.isUserAnEmployee"></app-customer-selection>
                    <div class="sidebar-title">
                        <div class="default-form-field">
                            <mat-label>{{ 'CONFIGURATION.OFFER_TITLE_PLACEHOLDER' | translate }}</mat-label>
                            <mat-form-field appearance="outline" (click)="onOfferTitleClick()">
                                <input
                                    data-at-quote-title
                                    #offerTitleInput
                                    matInput
                                    maxlength="100"
                                    [(ngModel)]="offerTitle"
                                    [errorStateMatcher]="errorOnEmptyMatcher"
                                    (keyup.enter)="onOfferTitleBlur()"
                                    (blur)="onOfferTitleBlur()"
                                />
                                <mat-hint *ngIf="!isOfferTitleDisabled" align="end"
                                    >{{ offerTitle.length }} / 100</mat-hint
                                >
                                <mat-error>
                                    {{ 'CONFIGURATION.VALIDATION.PLEASE_PROVIDE_TITLE_MESSAGE' | translate }}</mat-error
                                >
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="sidebar-price-product">
                        <mat-card>
                            <app-price-summary *ngIf="!isVitoclima"></app-price-summary>
                            <app-product-list></app-product-list>
                        </mat-card>
                    </div>
                    <button
                        class="next"
                        mat-raised-button
                        type="button"
                        color="primary"
                        [disabled]="
                            !isQuestFormComplete ||
                            (hasProductErrors | async) ||
                            (isPriceSummaryLoading | async)?.value ||
                            (isProductListLoading | async) ||
                            (isConfigurationUpdating | async)
                        "
                        (click)="submit()"
                    >
                        {{ 'CONFIGURATION.SUMMARY' | translate }}
                    </button>
                </div>
            </div>
        </div>
        <div main *ngIf="!isQuestFormReady">
            <app-loader [message]="loaderTextKey | translate"></app-loader>
        </div>
    </div>
</div>
